function downloadLoader() {
    const $ = jQuery.noConflict();

    const userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))) {
        return;
    }
    $('body').isLoading('dark');

    $(document).unbind('blur.downloadLoader').bind('blur.downloadLoader', function() {
        $('body').doneLoading();
        $(document).unbind('blur.downloadLoader');
    });
}